import {
  faFileInvoiceDollar,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import viewDashboardDetails from './viewDashboardDetails';

export default {
  name: 'adminDashboard',
  components: {
    faFileInvoiceDollar,
    faArrowRight,
    viewDashboardDetails
  },
  data() {
    return {
      count1: 0,
      showCard: false,
      cardName: null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: true,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      }
    };
  },
  mounted() {
    this.getPendingEmailCount();
  },
  methods: {
    // 1.0 <Anuj> To show hide view details from
    showHideCard(flag, type) {
      this.cardName = null;
      const typeCountMap = {
        pendingEmail: this.count1
      };
      if (type && typeCountMap[type] === 0) {
        this.$bvToast.toast('No records found.', {
          title: 'Alert',
          variant: 'danger',
          solid: true,
          autoHideDelay: 7000
        });
        return;
      }
      this.showCard = flag;
      this.cardName = type;
    },
    // 1.0 <Anuj> To get pending emails data count
    getPendingEmailCount() {
      this.loader = true;
      this.$store
        .dispatch('adminDashboard/getPendingEmailCount')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {            
            this.count1 = resp.data.data[0].total_email_count;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  }
};
